import React from 'react';
import PortalHeader from '../../components/PortalHeader/PortalHeader';
import PageContainer from '../../components/PageElements/PageContainer/PageContainer';
import PageBody from '../../components/PageElements/PageBody/PageBody';
import TermsContent from '../../components/Legal/TermsContent';

const Terms: React.FC = () => {
  return (
    <PageContainer>
      <PortalHeader 
        showContentHeader={false}
      />
      <PageBody>
        <div style={{ maxWidth: '900px', margin: '0 auto', color: 'var(--color-text-primary)' }}>
          <h1 style={{ fontSize: '32px', fontWeight: 800, marginBottom: '16px' }}>Terms & Conditions</h1>
          <p style={{ color: 'var(--color-text-secondary)', marginBottom: '24px' }}>
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <TermsContent />
        </div>
      </PageBody>
    </PageContainer>
  );
};

export default Terms;


